function isEmptyString(str?: string | null): boolean {
  return str === null || str === undefined || str.match(/^ *$/) !== null
}

export const isNonEmptyString = (str: string | null) => !isEmptyString(str)
